import React, { Component } from 'react'
import PropTypes from 'prop-types'
import omit from 'lodash/fp/omit'

import wrapperDisplayName from '../../utils/wrapperDisplayName'
import getInjectors from '../utils/reducerInjector'
import injectStore from './injectStore'

const omitStore = omit('store')

/**
 *
 * @param {Object} options - options to inject reducer
 * @param {String} options.key - key to inject reducer
 * @param {Function} options.reducer - reducer function
 * @param {Array<String>} [options.entities] - entities to register in state.entities
 * @return {Function} to create WithReducerComponent
 */
export default function injectReducer({ key, reducer, entities }) {
  /**
   * Create WithReducer component with passed options
   *
   * @param {Component|StatelessFunction} WrappedComponent - react component to wrap
   * @return {Component} WithReducerComponent
   */
  return WrappedComponent => {
    class WithReducer extends Component {
      static displayName = wrapperDisplayName('withReducer', WrappedComponent)

      static propTypes = {
        store: PropTypes.shape({
          history: PropTypes.object.isRequired,
          injectedReducers: PropTypes.object.isRequired,
          replaceReducer: PropTypes.func.isRequired
        }).isRequired
      }

      constructor(props) {
        super(props)

        this.injectors = getInjectors(props.store)
        this.injectors.injectReducer(key, reducer, { entities: entities || [] })
      }

      state = { didMount: false }

      componentDidMount() {
        this.setState({ didMount: true })
      }

      render() {
        if (!this.state.didMount) return null

        return <WrappedComponent {...omitStore(this.props)} />
      }
    }

    return injectStore(WithReducer)
  }
}
